"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { getToken } from "@/lib/auth";
import { getAdminMetrics } from "@/lib/requestor/admin-commerce";
import { HttpError } from "@/lib/network";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      router.replace("/login");
      return;
    }
    getAdminMetrics()
      .then(() => setReady(true))
      .catch((err) => {
        if (err instanceof HttpError) {
          if (err.status === 401) {
            router.replace("/login");
            return;
          }
          if (err.status === 403) {
            router.replace("/403");
            return;
          }
        }
        router.replace("/login");
      });
  }, [router]);

  if (!ready) {
    return <div className="h-screen flex items-center justify-center text-sm text-muted-foreground">鉴权中...</div>;
  }

  return <>{children}</>;
}
